import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class ColorModeService {
  constructor(private http: HttpClient) {}

  public switchMode(theme: string) {
    const url = `/api/v4/color-mode`;
    return this.http.put(url, { color_mode: theme });
  }
}
